import React from 'react';

const hasText = (value) => typeof value === 'string' && value.trim().length > 0;

const renderBlock = (block, blockIndex, classNamePrefix) => {
    const type = block?.type?.trim().toLowerCase();

    if (type === 'paragraph' && hasText(block.text)) {
        return <p key={`paragraph-${blockIndex}`}>{block.text}</p>;
    }

    if (type === 'bullets' && Array.isArray(block.items)) {
        const items = block.items.filter(hasText);
        if (items.length === 0) {
            return null;
        }

        return (
            <ul key={`bullets-${blockIndex}`} className={`${classNamePrefix}-list`}>
                {items.map((item, itemIndex) => (
                    <li key={`${itemIndex}-${item}`}>{item}</li>
                ))}
            </ul>
        );
    }

    return null;
};

const ReleaseNoteContent = ({ sections, classNamePrefix }) => {
    if (!Array.isArray(sections) || sections.length === 0) {
        return null;
    }

    return sections.map((section, sectionIndex) => {
        const blocks = Array.isArray(section?.blocks) ? section.blocks : [];

        return (
            <section
                className={`${classNamePrefix}-section`}
                key={`${sectionIndex}-${section?.heading || 'section'}`}
            >
                {hasText(section?.heading) && <h3>{section.heading}</h3>}
                {blocks.map((block, blockIndex) => renderBlock(block, blockIndex, classNamePrefix))}
            </section>
        );
    });
};

export const hasReleaseNoteSections = (sections) => Array.isArray(sections) && sections.length > 0;

export default ReleaseNoteContent;
